import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { breakpoints } from '@sorted/sorted-ui';
import { faTruck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CollapsingMenu from '../../Sidebar/CollapsingMenu';
import SubMenu, { SubMenuListItem as Li } from '../../Sidebar/SubMenu';
import hasProductClaims, { proClaim } from '../utils/hasProductClaims';
import MenuLink from '../../Sidebar/MenuLink';

const renderMenuIcon = (icon, size = 'lg') => (
	<FontAwesomeIcon
		style={{ pointerEvents: 'none' }}
		size={size}
		icon={icon}
		fixedWidth
	/>
);

const DesktopMenuLink = styled(MenuLink)`
	display: none;

	@media (min-width: ${breakpoints.smallDesktop}) {
		display: flex;
	}
`;

const ProMenu = ({ onShowHide, isOpen, sidebarCollapsed, productClaims }) => {
	if (hasProductClaims(productClaims, [proClaim])) {
		return (
			<CollapsingMenu
				Icon={() => renderMenuIcon(faTruck)}
				isCollapsed={sidebarCollapsed}
				onClick={onShowHide}
				open={isOpen}
				title="PRO"
			>
				<SubMenu label="PRO">
					<Li>
						<MenuLink to="/shipments/dashboard">
							View Shipments
						</MenuLink>
					</Li>
					<Li>
						<DesktopMenuLink to="/shipments/create-shipment">
							Create Shipment
						</DesktopMenuLink>
					</Li>
					<Li>
						<MenuLink to="/shipments/shipments-groups">
							Shipments Groups
						</MenuLink>
					</Li>
				</SubMenu>
			</CollapsingMenu>
		);
	}

	return null;
};

ProMenu.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	sidebarCollapsed: PropTypes.bool,
	productClaims: PropTypes.arrayOf(PropTypes.string).isRequired
};

ProMenu.defaultProps = {
	sidebarCollapsed: false
};

export default ProMenu;
